import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, TextField } from '@material-ui/core'
import { Table, TableBody, TableHead, TableCell, TableRow } from '@material-ui/core'
import moment from 'moment'
import { getUser } from '../../actions/users'
import { getTeam, setTeam } from '../../actions/teams'
import { getInvite, newInvite } from '../../actions/invites'
import { getStage } from '../../actions/stages'
import Navigation from '../../components/navigation'
import Breadcrumbs from '../../components/breadcrumbs'
import StageDetails from '../../components/stagedetails'
import Dialog from '../../components/dialog'

import './styles.css'

const teamNameValid = (name) => {
  return (typeof name === 'string' && name.length > 3)
}

const emailValid = (email) => {
  return (typeof email === 'string' && email.includes('@'))
}

class Team extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleInvite = this.handleInvite.bind(this)
    this.handleStage = this.handleStage.bind(this)
    this.handleStageSelection = this.handleStageSelection.bind(this)
    this.state = {
      teamName: '',
      newMemberEmail: '',
      showStagesDialog: false
    }
  }

  static get propTypes () {
    return { teamId: PropTypes.string.isRequired }
  }

  componentDidMount () {
    this.updateData()
  }

  render () {
    const team = this.props.teams[this.props.teamId]

    const members = ((team || {}).members || [])
      .map(userId => this.props.users[userId])
      .filter(user => (typeof user !== 'undefined'))
      .sort((a, b) => a.created - b.created)
      .map(user => this.createMemberRow(user))

    const invites =  ((team || {}).invites || [])
      .map(inviteId => this.props.invites[inviteId])
      .filter(invite => (typeof invite !== 'undefined') && (invite.deleted === false))
      .sort((a, b) => a.created - b.created)
      .map(invite => this.createInviteRow(invite))

    const officialStage = team ? this.props.stages[team.officialStage] : null

    return (
      <div className='scenes-team'>
        <Navigation title='Team Members'/>
        <Breadcrumbs config={[{ url: '/', title: 'Dashboard' }, { url: '/teams', title: 'Teams' }, { title: 'Team' }]} />
        <div className='box'>
          {team && (
            <div className='section'>
              <div className='section-title'>Team Properties</div>
              <TextField placeholder="Team Name" value={this.state.teamName} onChange={event => this.setState({ teamName: event.target.value })} />
              <div className='horizontal-spacer' />
              <Button variant='contained' color='primary'onClick={this.handleChange} disabled={!teamNameValid(this.state.teamName)}>Change</Button>
            </div>
          )}
        </div>
        <div className='box'>
          <div className='section'>
            <div className='section-title'>Team Members</div>
            <small className="form-text text-muted">
              People become team members if they where invited into your team and when they payed their entrance fee. 
              Add people to your team by inviting them in the <i>Team Invites</i> section below.
            </small>
            {(members.length > 0) && (
              <div className='members-list'>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Email</TableCell>
                      <TableCell>First Name</TableCell>
                      <TableCell>Last Name</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {members}
                  </TableBody>
                </Table>
              </div>
            )}
          </div>
        </div>
        <div className='box'>
          <div className='section'>
            <div className='section-title'>Team Invites</div>
            <small className="form-text text-muted">
              Invite a team member by entering this person's email address. We will send an invitation email. 
              If for some reason this person isn't receiving the email, 
              you can send the invitation link manualy using some other form of communication.
            </small>
            {(invites.length > 0) && (
              <div className='invite-list'>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Invite Link</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Created</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invites}
                  </TableBody>
                </Table>
              </div>
            )}
          </div>
          <div>
            <TextField placeholder="Invitee Email" value={this.state.newMemberEmail} onChange={event => this.setState({ newMemberEmail: event.target.value })} />
            <div className='horizontal-spacer' />
            <Button variant='contained' color='primary' onClick={this.handleInvite} disabled={!emailValid(this.state.newMemberEmail)}>Invite</Button>
          </div>
        </div>
        {officialStage && (
          <div className='box'>
            <div className='section'>
              <div className='section-title'>Linked Stage</div>
              <StageDetails stage={officialStage} />
            </div>
          </div>
        )}
        {this.state.inviteDetails && (
          <Dialog title={'Invite link for ' + this.state.inviteDetails.email} actions={[{title: 'Done'}]} onAction={() => this.setState({ inviteDetails: null }) }>
            Send the link below to the person you like to invite:
            <p>
              <samp>https://panel.runthemarenostrum.com/?inviteId={this.state.inviteDetails.inviteId}</samp>
            </p>
          </Dialog>
        )}
      </div>
    )
  }

  handleStageSelection (selection) {
    this.setState({ showStagesDialog: false })
  }

  handleStage () {
    this.setState({ showStagesDialog: true })
  }

  handleChange () {
    const team = this.props.teams[this.props.teamId]
    if (team && teamNameValid(this.state.teamName)) {
      this.props.setTeam(team.teamId, this.state.teamName, team.leaderId)
    }
  }

  handleInvite () {
    const team = this.props.teams[this.props.teamId]
    if (team && emailValid(this.state.newMemberEmail)) {
      this.props.newInvite(team.teamId, this.state.newMemberEmail)
        .then(this.updateData.bind(this))
    }
  }

  createMemberRow (member) {
    return (
      <TableRow key={member.userId}>
        <TableCell>{member.email}</TableCell>
        <TableCell>{member.firstName}</TableCell>
        <TableCell>{member.lastName}</TableCell>
      </TableRow>
    )
  }

  createInviteRow (invite) {
    const created = new Date(parseInt(invite.created, 10))
    return (
      <TableRow key={invite.inviteId}>
        <TableCell><Button variant='text' color='primary' onClick={() => this.setState({ inviteDetails: invite })}>Get Link</Button></TableCell>
        <TableCell>{invite.email}</TableCell>
        <TableCell>{moment(created).fromNow()}</TableCell>
      </TableRow>
    )
  }

  createStageRow (stage) {
    return (
      <TableRow key={stage.stageId}>
        <TableCell>{stage.startCity}</TableCell>
        <TableCell>{stage.stopCity}</TableCell>
      </TableRow>
    )
  }

  updateData () {
    return this.props.getTeam(this.props.teamId).then(() => {
      const team = (this.props.teams)[this.props.teamId]
      if (team) {
        if (team.members) {
          this.setState({ teamName: team.name })
          team.members.forEach(userId => {
            this.props.getUser(userId)    
          })
        }
        if (team.invites) {
          team.invites.forEach(inviteId => {
            this.props.getInvite(inviteId)    
          })
        }
        if (team.officialStage) {
          this.props.getStage(team.officialStage)
        }
      }
    })
  }
}

const mapDispatch = (dispatch) => {
  return {
    getUser: (userId) => getUser(userId)(dispatch),
    getTeam: (teamId) => getTeam(teamId)(dispatch),
    setTeam: (teamId, name, leaderId) => setTeam(teamId, name, leaderId)(dispatch),
    getInvite: (teamId, inviteId) => getInvite(teamId, inviteId)(dispatch),
    newInvite: (teamId, email) => newInvite(teamId, email)(dispatch),
    getStage: (stageId) => getStage(stageId)(dispatch)
  }
}

const mapState = (state) => ({ 
  teams: (state.teams.list || {}),
  users: (state.users.list || {}),
  invites: (state.invites.list || {}),
  stages: (state.stages.list || {}),
  userId: state.cognito.userId
})

export default connect(mapState, mapDispatch)(Team)
